<template>
  <div
    class="html_teamForPlayerColumn"
    ref="html_teamForPlayerColumn"
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="main">
      <div class="headerArea">
        <template v-if="['A', 'D', 'T'].includes(themetype)">
          <DelegationImgRow
            v-for="item in datas.objectInfo"
            :key="item.teamId"
            :countryImg="item.teamLogo"
            :countryName="item.teamName"
            :cssDynamicObj="cssDynamicObj"
            :themetype="themetype"
            :playerInfos="item.playerInfos"
            :width="'100%'"
            :logoWidth="'calc(3.6vw * var(--mixtmt_mixvw))'"
            :logoHeight="'calc(2.4vw * var(--mixtmt_mixvw))'"
          ></DelegationImgRow>
        </template>
        <!-- <span class="rightArea"></span> -->
      </div>
      <div class="table_box" :class="themetype">
        <span class="t_body">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="(columnItem, columnIndex) in table_column_arr"
              :key="columnItem.statisticalEn"
            >
              <template v-if="inFilterDataType_select && columnItem.isFilter">
                <IndicatorItemsSelect
                  :cssDynamicObj="cssDynamicObj"
                  :selectList="
                    JSON.parse(JSON.stringify(inFilterDataType_select))
                  "
                  :selectId="columnItem.id + ''"
                  :indexNo="columnIndex"
                  @changeValEvent="changeValEventHandler"
                ></IndicatorItemsSelect>
              </template>
              <template v-else>
                <span class="valString" v-text="columnItem.name"></span>
              </template>
            </span>
          </span>
          <span
            class="customTable_row"
            v-for="(rowData, rowIndex) in datas.data.dataList"
            :key="rowIndex"
          >
            <span
              class="customTable_row_cell"
              v-for="columnItem in table_column_arr"
              :key="columnItem.statisticalEn"
            >
              <NumberScrolling
                :tarVal="_valFormatHandler(rowData[columnItem.statisticalEn])"
                :unit="columnItem.suffix"
              ></NumberScrolling>
            </span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 球队中的球员数据 类似table表格， 动态筛选表头
import DelegationImgRow from '../components/DelegationImgRow'
import NumberScrolling from '../components/NumberScrolling'
import IndicatorItemsSelect from '../components/IndicatorItemsSelect'
export default {
  name: 'html_teamForPlayerColumn',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    DelegationImgRow,
    NumberScrolling,
    IndicatorItemsSelect,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    inFilter: {
      type: Object,
      default: () => ({
        filterId: 0,
        filterTypes: [],
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    graphicsId: {
      type: String,
      default: '3033',
    },
  },
  data() {
    return {
      // themetype: 'A', //A:单人；D:双人；T:团队
      // sportType: 'uncombat', //combat: 对抗； uncombat:非对抗
      inFilterDataType: null,
      inFilterDataType_select: null,
    }
  },
  created() {
    // 模拟数据
    console.debug('html_teamForPlayerColumn:', this.datas, this.inFilter)
    this.initInFilteOpt(this.inFilter)
    this.$nextTick(() => {
      // 设置CSS变量--main-bg-color的值为'#f0f0f0'
      document.body.style.setProperty(
        '--mixtmt_indicatorItemSelect_mixvw',
        this.cssDynamicObj.mixvw
      )
    })
  },
  watch: {
    inFilter: {
      handler(newValue, oldValue) {
        console.debug('inFilter:', newValue, oldValue)
        if (newValue) {
          this.initInFilteOpt(newValue)
        }
      },
      immediate: false,
      deep: true,
    },
  },
  computed: {
    themetype() {
      let themeType = 'T'
      if (
        this.datas.objectInfo &&
        this.datas.objectInfo[0].playerInfos &&
        this.datas.objectInfo[0].playerInfos.length > 0
      ) {
        if (this.datas.objectInfo[0].playerInfos.length === 1) {
          themeType = 'A'
        } else if (this.datas.objectInfo[0].playerInfos.length === 2) {
          themeType = 'D'
        }
      }
      return themeType
    },
    // sportType() {
    //   let sportType = ''
    //   const len = this.datas.data.dataList[0].showDataList.length
    //   if (len === 1) {
    //     sportType = 'uncombat'
    //   } else if (len === 2) {
    //     sportType = 'combat'
    //   }
    //   return sportType
    // },
    table_column_arr() {
      let fixed_table_column_arr = []
      let isFilter = false
      if (this.graphicsId === '3031') {
        // 3031是针对 冰壶 的
        isFilter = true
        fixed_table_column_arr = [
          {
            id: -1,
            name: '运动员',
            tableName: null,
            columnName: 'player_name',
            type: null,
            sort: -1,
            statisticalEn: 'playerName',
            suffix: '',
            isAuto: null,
            high: null,
            isFilter: false,
          },
          {
            id: -1,
            name: '位置',
            tableName: null,
            columnName: 'position_name',
            type: null,
            sort: -1,
            statisticalEn: 'positionName',
            suffix: '',
            isAuto: null,
            high: null,
            isFilter: false,
          },
        ]
      }
      const dynamic_table_column_arr = []
      this.datas.statisticsModels.forEach((modelItem) => {
        modelItem.isFilter = isFilter
        dynamic_table_column_arr.push(modelItem)
      })
      return [].concat(fixed_table_column_arr, dynamic_table_column_arr)
    },
  },
  methods: {
    initInFilteOpt(inFilter) {
      console.debug('initInFilteOpt', inFilter)
      if (inFilter && inFilter.filterTypes && inFilter.filterTypes[0]) {
        this.inFilterDataType = inFilter.filterTypes[0]
        this.inFilterDataType_select = this.inFilterDataType.values.map(
          (selectItem) => {
            // 不会触及到修改原来的数据
            let newItem = JSON.parse(JSON.stringify(selectItem))
            newItem.value = selectItem.value + ''
            return newItem
          }
        )
      }
    },
    changeValEventHandler(childData) {
      this.$emit('inFilterChangeEvent', {
        data: Object.assign({}, childData, {
          inFilterKey: this.inFilterDataType.name, // 'statisticalIds'
          graphicsId: this.datas.graphicsId,
          analysisItemId: this.datas.analysisItemId,
        }),
      })
    },
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '一'
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_teamForPlayerColumn {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 94%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .headerArea {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: calc(1.11vw * var(--mixtmt_mixvw));
      /* .leftArea {
        width: 50%;
      }
      .rightArea {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: bold;
        padding-bottom: calc(0.694vw * var(--mixtmt_mixvw));
        color: var(--mixtmt_greyColor3);
        span {
          font-size: calc(1.11vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
        }
      } */
    }
    .table_box {
      position: relative;
      width: 100%;
      height: auto;
      display: table;
      /* display: block; */
      /* table-layout: auto; */
      /* padding-top: 2.083vw; */
      /* .t_header {
          width: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          .customTable_row {
            display: table-row;
            height: 2.083vw;
            color: var(--mixtmt_greyColor4);
            width: 100%;
            background: linear-gradient(
              180deg,
              var(--mixtmt_theme_defaultGradient_1_1) 0%,
              var(--mixtmt_theme_defaultGradient_1_2) 98%
            );
            color: var(--mixtmt_whiteColor);
            border-bottom: 0;
            .customTable_row_cell {
              font-size: 0.972vw;
              border-bottom: 0;
            }
          }
        } */
      .t_body {
        width: 100%;
        height: auto;
        /* display: table; */
        /* display: block; */
        display: table;
        /* flex-direction: column; */
        max-height: calc(15.62vw * var(--mixtmt_mixvw));
        overflow: auto;
      }

      .customTable_row {
        display: table-row;
        height: calc(2.083vw * var(--mixtmt_mixvw));
        color: var(--mixtmt_greyColor4);
        &:first-child {
          position: sticky;
          top: 0;
          right: 3%;
          z-index: 2;
          display: table-row;
          height: calc(2.788vw * var(--mixtmt_mixvw));
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            height: inherit;
            padding: 0;
            font-size: calc(0.972vw * var(--mixtmt_mixvw));
            border-bottom: 0;
          }
        }
      }

      .customTable_row_cell {
        display: table-cell;
        padding: calc(0.486vw * var(--mixtmt_mixvw)) 0;
        font-size: calc(0.833vw * var(--mixtmt_mixvw));
        line-height: calc(1.11vw * var(--mixtmt_mixvw));
        font-weight: bold;
        text-align: center;
        width: 5%;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        vertical-align: middle;
      }
    }
  }
}
</style>
